import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';

export class InvoiceDetailsCustomerColumn extends React.Component {

  static propTypes = {
    showMoreIsVisible: PropTypes.bool,
    invoice: PropTypes.object
  };

  render () {
    let invoice = this.props.invoice;
    if (invoice && invoice.customer) {
      const reference = (<div className='invoice-details-row'>
        <b><Translate content='INVOICE_DETAILS_INVOICING_REFERENCE' />:</b> {invoice.customer.contact}
      </div>);

      let email = invoice.customer.sendToEmail
        ? (<div className='invoice-details-row'>
          <b><Translate content='EMAIL' /> :</b> {invoice.customer.sendToEmail}
        </div>)
        : null;

      return (
        <div
          className={'invoice-details-row-column' + (this.props.showMoreIsVisible ? ' padding-no-top' : ' padding')}
        >
          <div className='invoice-details-title'>
            <Translate content='INVOICE_DETAILS_INVOICING_RECIPIENT' />
          </div>
          <div className='invoice-details-row'>{invoice.customer.name}, {invoice.customer.vatNr}</div>
          <div className='invoice-details-row'>{invoice.customer.address.street}</div>
          <div className='invoice-details-row'>{invoice.customer.address.zip}, {invoice.customer.address.city}</div>
          <div className='invoice-details-row'>{invoice.customer.address.country}</div>
          <div className='invoice-details-row-divider'></div>
          {reference}
          {email}
        </div>
      );
    }
    return null;
  }
}

export default InvoiceDetailsCustomerColumn;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-details/customer-column.js
 **/